import { createTestIdHelper } from '../../../lib/utils';

/**
 * Kept out of the component file so that module only exports components: a non-component
 * export there breaks Fast Refresh (`react-refresh/only-export-components`).
 */
export const restrictedPlaceholderTestId = createTestIdHelper(
  'restricted-placeholder',
);

export const restrictedPlaceholderTestIds = {
  root: restrictedPlaceholderTestId('root'),
  icon: restrictedPlaceholderTestId('icon'),
  title: restrictedPlaceholderTestId('title'),
  description: restrictedPlaceholderTestId('description'),
  action: restrictedPlaceholderTestId('action'),
} as const;
